/**
 * Several currencies have cash rounding, which occurs when the amount payable is smaller
 * than the lowest physical denomination of currency. If paying by cash in such a scenario, the amount payable
 * is rounded to the nearest multiple of the minimum currency unit available.
 *
 * Both iOS and Android ship a plist and a jar file with a list of cash rounding for various currencies.
 * https://git.sqcorp.co/projects/sq/repos/java/browse/shared-protos/common/src/main/proto/squareup/common/currency_codes.proto
 *
 * This is Dashboard's implementation of it. It currently only has 2 currencies but can be expanded further
 * when needed.
 */
const CASH_ROUNDING = {
  CAD: 5,
  AUD: 5
};
export default function cashRounding(currencyCode) {
  return currencyCode in CASH_ROUNDING ? CASH_ROUNDING[currencyCode] : 1;
}